"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteContentItem = void 0;
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../../common");
const popup_1 = require("../../../base/popup");
const DeletePopUpLayout_1 = require("../../../base/layout/DeletePopUpLayout");
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const server_1 = require("../../../../server");
const Colors_1 = require("../../../../Colors");
const DeleteContentItem = ({ menu, deleteList }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const deleteMutation = (0, react_query_1.useMutation)(server_1.deleteContentsList);
    const onDelete = async () => {
        const successfulDeletes = [];
        const failedDeletes = [];
        const deleteHandler = async (id) => {
            try {
                await deleteMutation.mutateAsync(id);
                successfulDeletes.push(id);
            }
            catch (error) {
                failedDeletes.push(id);
            }
        };
        try {
            const deletePromises = deleteList.map(id => deleteHandler(id));
            await Promise.all(deletePromises);
        }
        catch (error) {
            alert(error);
        }
        finally {
            // Log successful and failed deletions
            // if (successfulDeletes.length) {
            // 	console.log('Successfully deleted ids:', successfulDeletes);
            // }
            // if (failedDeletes.length) {
            // 	console.error('Failed to delete ids:', failedDeletes);
            // }
            // Refresh the contents
            APP.eventManager.publish('REFRESH_CONTENTS');
        }
    };
    const handlerDel = () => {
        if (deleteList.length <= 0)
            return;
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DeletePopUpLayout_1.DeletePopUpLayout,
            componentProps: {
                deleteContent: deleteList.length
                    ? t('assignment.delteInto', { count: deleteList?.length })
                    : t('common.notSelect'),
                onDelete: onDelete,
            },
            width: 639,
            title: t(`supportRoom.${menu}Delete`),
            isFit: true,
        });
    };
    return (react_1.default.createElement(common_1.Button, { option: {
            buttonAfterIcon: {
                show: true,
                name: 'delete',
                color: Colors_1.Colors.pink,
                size: 20,
            },
        }, onClick: () => handlerDel() }));
};
exports.DeleteContentItem = DeleteContentItem;
